import { getCompanyContactDataById } from '../companyContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOrderMSContact } from '~/types/order/models'

const orderMSContactListData = undefined as unknown as IOrderMSContact[]

export const getOrderMSContactListData = getListDataFunctionFactory<
  IOrderMSContact[]
>({
  listData: orderMSContactListData,
  storageKey: 'ordermscontacts',
  getStartingListData: getStartingOrderMSContactListData,
})

export async function getOrderMSContactListDataByMOMSId(id: TEntityId) {
  const listData = await getOrderMSContactListData()
  return listData.filter(
    (omsct: IOrderMSContact) => omsct.orderMasterService.id === id
  )
}

export async function getOrderMSContactDataById(
  id: TEntityId
): Promise<IOrderMSContact | undefined> {
  const listData = await getOrderMSContactListData()
  return listData.find((omsc: IOrderMSContact) => omsc.id === id)
}

export async function getStartingOrderMSContactListData(): Promise<
  IOrderMSContact[]
> {
  return [
    {
      id: 'XXORDMSC0001',
      hrid: 'ORDMSC0001',
      orderMasterService: {
        id: 'XXORDMS0001',
        label: 'DIA - Target & Big Mac',
      },
      contact: await getCompanyContactDataById('XXCCT0017')!,
      splitFraction: null,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
